import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { removeAuthToken } from '../utils/auth'

function ErrorPage() {

  const error = useRouteError()

  let title = 'Algo deu errado'
  let message = 'Ocorreu um erro inesperado. Tente novamente mais tarde.'

  if (isRouteErrorResponse(error)) {
    removeAuthToken()
    if (error.status === 404) {
      title = 'Página não encontrada'
      message = 'A página que você procura não existe ou foi removida.'
    } else {
      title = `Erro inesperado!`
      message = error.statusText || message
    }
  }

  return (
    <main>
      <nav>
        <div className="relative container mx-auto p-6 flex items-center justify-center lg:w-6xl">
          <div className="flex items-center">
            <a href="/"><img src="/images/logo-small.png" alt="Bolão da Copa"/></a>
          </div>
        </div>
      </nav>

      <section>
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
          <h1 className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
            {title}
          </h1>
          <p className="mb-6 text-gray-700">{message}</p>
          <Link className="font-medium text-green-600 hover:underline" to="/">Voltar para o início</Link>
        </div>
      </section>
    </main>
  )
}

export default ErrorPage
